var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshopIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1055,
    height: 400,
    viewBox: "0 0 1055 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_566_557)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2891 66.1213C44.8472 63.2827 47.0291 56.4311 44.1624 50.8177C41.2956 45.2044 34.4659 42.955 28.9077 45.7936C23.3495 48.6321 21.1677 55.4837 24.0344 61.0971C26.9011 66.7104 33.7309 68.9598 39.2891 66.1213Z",
    fill: "#F432F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0615 93.9369C43.6197 91.0984 45.8016 84.2468 42.9348 78.6334C40.0681 73.0201 33.2384 70.7707 27.6802 73.6092C22.122 76.4478 19.9402 83.2994 22.8069 88.9127C25.6736 94.5261 32.5033 96.7755 38.0615 93.9369Z",
    fill: "#F432F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5439 81.4342C68.1021 78.5957 70.284 71.7441 67.4173 66.1307C64.5505 60.5174 57.7208 58.268 52.1626 61.1065C46.6044 63.9451 44.4226 70.7967 47.2893 76.4101C50.156 82.0234 56.9858 84.2728 62.5439 81.4342Z",
    fill: "#F432F9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.8825 47.1766C20.8629 45.9093 22.1277 44.8347 23.646 44.0593C29.2055 41.2201 36.0342 43.4706 38.9007 49.0835C41.7672 54.6964 39.5877 61.5495 34.0282 64.3888C28.4688 67.228 21.6401 64.9775 18.7727 59.3628C18.2071 58.2553 17.8382 57.1004 17.6552 55.9367",
    stroke: "#F432F9",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3697 49.7963C17.957 50.7958 17.6899 51.8536 17.5768 52.9343",
    stroke: "#F432F9",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1426 71.2485C33.8686 72.1697 36.2555 74.1234 37.674 76.9009C40.5405 82.5138 38.3584 89.3661 32.8007 92.2044C27.243 95.0428 20.4126 92.7931 17.5461 87.1802C14.6796 81.5673 16.859 74.7142 22.4185 71.875C24.289 70.9197 26.3046 70.5399 28.2655 70.6741",
    stroke: "#F432F9",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2822 79.7018C62.8404 76.8633 65.0223 70.0116 62.1555 64.3983C59.2888 58.785 52.4591 56.5356 46.9009 59.3741C41.3427 62.2127 39.1609 69.0643 42.0276 74.6776C44.8943 80.291 51.724 82.5404 57.2822 79.7018Z",
    stroke: "#F432F9",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_566_557)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M999.059 69.0317C992.157 58.0999 979.341 52.4083 966.602 54.6172L985.702 11.6108C998.441 9.40185 1011.26 15.0934 1018.16 26.0253L999.059 69.0317Z",
    fill: "#754BE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.52 83.4463C1024.61 72.5145 1011.8 66.8229 999.06 69.0318L1018.16 26.0253C1030.9 23.8164 1043.71 29.508 1050.62 40.4398L1031.52 83.4463Z",
    fill: "#754BE3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1019.4 20.3269C1031.01 19.5304 1042.26 25.1467 1048.57 35.1381L1029.47 78.1446C1022.57 67.2128 1009.76 61.5212 997.017 63.7301C990.115 52.7983 977.299 47.1067 964.56 49.3156L983.66 6.30909C996.399 4.10019 1009.21 9.79178 1016.12 20.7236L998.43 60.5495",
    stroke: "#754BE3",
    strokeWidth: 3,
    strokeMiterlimit: 3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_566_557)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7426 378.91C60.8557 377.49 47.481 384.586 40.8697 396.88L17.0584 351.998C23.6697 339.703 37.0445 332.608 50.9314 334.027L74.7426 378.91Z",
    fill: "#754BE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.616 360.94C94.7288 359.52 81.354 366.616 74.7427 378.91L50.9315 334.027C57.5428 321.733 70.9175 314.637 84.8044 316.057L108.616 360.94Z",
    fill: "#754BE3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.9175 329.177C53.9798 318.779 66.2478 312.962 78.9402 314.26L102.751 359.142C88.8646 357.723 75.4898 364.818 68.8785 377.113C54.9916 375.693 41.6168 382.789 35.0055 395.083L11.1943 350.2C17.8056 337.906 31.1804 330.81 45.0672 332.23L67.1175 373.793",
    stroke: "#754BE3",
    strokeWidth: 3,
    strokeMiterlimit: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_566_557)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M978.973 281.94C964.7 271.226 944.44 274.12 933.722 288.4C923.003 302.681 925.885 322.94 940.158 333.654C954.432 344.367 974.692 341.477 985.41 327.196C996.129 312.916 993.249 292.655 978.973 281.94ZM947.471 323.91C938.592 317.246 936.792 304.594 943.46 295.71L975.672 319.887C969.004 328.771 956.353 330.577 947.471 323.91Z",
    fill: "#754BE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.031 301.459C991.018 300.277 990.943 299.1 990.801 297.93",
    stroke: "#754BE3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.904 304.681C990.386 310.47 988.301 316.189 984.556 321.179C973.836 335.461 953.576 338.351 939.302 327.638C925.029 316.924 922.146 296.664 932.866 282.381C943.586 268.099 963.844 265.21 978.118 275.924C984.364 280.612 988.428 287.126 990.126 294.167C990.172 294.36 990.218 294.553 990.261 294.746",
    stroke: "#754BE3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.604 289.694L974.816 313.871C968.147 322.757 955.496 324.562 946.616 317.898C939.226 312.351 936.739 302.657 939.956 294.439",
    stroke: "#754BE3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_566_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 52,
    fill: "white",
    transform: "translate(0 55.0151) rotate(-27.0534)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_566_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.0529,
    height: 57.5535,
    fill: "white",
    transform: "translate(985.36) rotate(23.9465)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_566_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.115,
    height: 62.1411,
    fill: "white",
    transform: "translate(6.9668 344.552) rotate(-27.9469)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_566_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.0412,
    height: 70.0412,
    fill: "white",
    transform: "translate(952.045 255) rotate(36.8909)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopIcons);
export default __webpack_public_path__ + "static/media/workshop_icons.9d794b141f8c85ba459c281f8ba52e0d.svg";
export { ForwardRef as ReactComponent };